import { render, staticRenderFns } from "./provinceFixPriceTable.vue?vue&type=template&id=61e49ab4"
import script from "./provinceFixPriceTable.vue?vue&type=script&lang=js"
export * from "./provinceFixPriceTable.vue?vue&type=script&lang=js"
import style0 from "./provinceFixPriceTable.vue?vue&type=style&index=0&id=61e49ab4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e49ab4')) {
      api.createRecord('61e49ab4', component.options)
    } else {
      api.reload('61e49ab4', component.options)
    }
    module.hot.accept("./provinceFixPriceTable.vue?vue&type=template&id=61e49ab4", function () {
      api.rerender('61e49ab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopOperationCenter/components/provinceFixPriceTable.vue"
export default component.exports